import React from 'react';
import { Box, HStack } from '@gluestack-ui/themed';

import type { MetricsFilters } from '@/common/api/models/metricsFilters';

import { DateRangeFilterControl, REPORT_FILTER_CONTROLS } from './filterControls';
import type { MetricsReportFilterKey, MetricsReportFilters } from './reportFilterDefaults';

export type ReportFilterBarProps = {
  /** Applied filters (from URL + defaults) shown in the bar. */
  filters: MetricsFilters;
  filterNames: MetricsReportFilterKey[];
  setFilter: <K extends MetricsReportFilterKey>(name: K, value: MetricsReportFilters[K]) => void;
  /** When true, date dropdown shows the last-90-days preset in its closed label. */
  useLast90DaysPreset?: boolean;
  disabled?: boolean;
};

/**
 * One registered control per filter name; F1 shows gated pill and date range.
 */
export function ReportFilterBar({
  filters,
  filterNames,
  setFilter,
  useLast90DaysPreset = false,
  disabled = false,
}: ReportFilterBarProps) {
  const showDateRange = filterNames.includes('from') || filterNames.includes('to');

  return (
    <HStack
      space="lg"
      alignItems="center"
      flexWrap="wrap"
      testID="report-filter-bar"
    >
      {filterNames.includes('gated') && (
        <Box alignSelf="flex-start" flexShrink={0}>
          {REPORT_FILTER_CONTROLS.gated?.({ filters, setFilter, disabled })}
        </Box>
      )}
      {!!showDateRange && (
        <DateRangeFilterControl
          filters={filters}
          setFilter={setFilter}
          disabled={disabled}
          useLast90DaysPreset={useLast90DaysPreset}
        />
      )}
      {filterNames.includes('excludePasteHeavy') && (
        REPORT_FILTER_CONTROLS.excludePasteHeavy?.({ filters, setFilter, disabled })
      )}
      {filterNames.includes('excludeFirstTryPasses') && (
        REPORT_FILTER_CONTROLS.excludeFirstTryPasses?.({ filters, setFilter, disabled })
      )}
    </HStack>
  );
}
